import axios from '../config/index';

const auth = {
    Login: (data) => axios.post('/auth/login', data),
    Logout: (data) => axios.post(`/auth/logout`, data),
    VerifyToken: (data) => axios.post(`/auth/verify-token`, data),
    RefreshToken: (data) => axios.post(`/auth/refresh-token`, data)
};
export default auth;
